export const config = {
  id: 'product-designer',
  icon: 'Layers',
  color: 'blue',
  title: 'Product Designer',
  description: 'End-to-end product design, user experience, and design strategy',
  department: 'Design',
  experienceLevels: ['junior', 'mid', 'senior'],
  operatingSystems: ['macos', 'windows', 'linux'],
  estimatedOnboardingDays: {
    junior: 4,
    mid: 3,
    senior: 2
  }
};
